import { WorkflowAction } from "app/utility/enums";
import { SaleDetails_SaleProductMvi } from "./saleDetails.model";
import { LookupExternalModel } from "../shared/lookup.model";

export class ProductQuoteModel
{
    mviQuote: ProductQuoteMviModel;
    referredMessage: string;
    referredReason: string;
    requiresReferral: boolean;
    referralPolicyId: string;
    generalMessage: string;
    nextStatus: WorkflowAction;

    originalMviFields: SaleDetails_SaleProductMvi;
    mviFields: SaleDetails_SaleProductMvi;
}

export class ProductQuoteMviModel
{
    paymentMethodId: string;
    selectedProductId: string;
    paymentMethod: LookupExternalModel[];
    
    selectedProduct: ProductQuoteMviProductModel;
    products: ProductQuoteMviProductModel[] = [];
}

export class ProductQuoteMviProductModel
{
    id: string;
    productName: string;
    productDescription: string;
    saleAmount: number;
    saleTaxStatusEnum: number;
    buyAmount: number;
    buyTaxStatusEnum: number;
    installmentFirst: number;
    installmentSubsequent: number;
    standardExcess: number;
    isImmobilizerRequired: boolean;
    roadsideAssistance: ProductQuoteOptionModel;
    windscreenCover: ProductQuoteOptionModel;
    allowNamedDriversOnly: ProductQuoteOptionModel;
    excludeDriversUnder25: ProductQuoteOptionModel;
    noClaimsBonusProtection: ProductQuoteOptionModel;
    voluntaryExcesses: ProductQuoteOptionExcessModel[];
    rentalCarExcesses: ProductQuoteOptionExcessModel[];
}

export class ProductQuoteOptionModel
{
    value: number;
}

export class ProductQuoteOptionExcessModel extends ProductQuoteOptionModel
{
    excess: number;
}